<app-leveltwo [pageName]="'General Info'">
    <div heading="General Info" class="General">
    <br>
      <h3>{{'CalculateFMV.SearchTitle'|translate}}</h3><br>
      <p>{{'CalculateFMV.Thefair'|translate}}</p>
      <p>{{'CalculateFMV.Utilizing'|translate}}</p>
      <h4>{{'CalculateFMV.Understanding'|translate}}</h4>
      <p>{{'CalculateFMV.Valuingahome'|translate}}</p>
      <h4>{{'CalculateFMV.Checkout'|translate}}</h4>
      <p>{{'CalculateFMV.Researching'|translate}}</p>
      <h4>{{'CalculateFMV.Figureout'|translate}}</h4>
      <p>{{'CalculateFMV.Foreach'|translate}}</p>
      <ul>
        <li>{{'CalculateFMV.PropertyA'|translate}}</li>
        <li>{{'CalculateFMV.PropertyB'|translate}}</li>
        <li>{{'CalculateFMV.PropertyC'|translate}}</li>
        <li>{{'CalculateFMV.PropertyD'|translate}}</li>
      </ul>
      <p>{{'CalculateFMV.Theaverage'|translate}}</p>
      <h4>{{'CalculateFMV.Consider'|translate}}</h4>
      <p>{{'CalculateFMV.While'|translate}}</p>
      <h4>{{'CalculateFMV.Godown'|translate}}</h4>
      <p>{{'CalculateFMV.Tosense'|translate}}</p>

    </div>
    <!-- <tab heading="FAQ">FAQ</tab>
    <tab heading="Forms">Forms</tab> -->
</app-leveltwo>

